export default __webpack_public_path__ + "static/media/gallery_23.8863912f.jpg";